<div class="layout-topbar">
  <div class="topbar-left">
    <a
      tabindex="0"
      #menubutton
      type="button"
      class="menu-button"
      (click)="onMenuButtonClick()"
      role="button"
      (keydown.enter)="onMenuButtonClick()"
    >
      <i class="pi pi-bars"></i>
    </a>
    <img
      class="horizontal-logo"
      [src]="clientConfig.logo_url || './icons/logo-d2d.svg'"
      alt="logo"
    />
    <span class="topbar-separator"></span>
    <div app-breadcrumb></div>
    <a routerLink="/">
      <img class="mobile-logo" [src]="clientConfig.logo_url || './icons/logo-d2d.svg'" alt="logo" />
    </a>
  </div>

  <div class="topbar-right">
    <ul class="topbar-menu">
      <li class="right-sidebar-item">
        <a
          class="right-sidebar-button"
          (click)="onConfigButtonClick()"
          tabindex="0"
          role="button"
          (keydown.enter)="onConfigButtonClick()"
        >
          <i class="pi pi-sliders-h"></i>
        </a>
      </li>
      <li class="right-sidebar-item static sm:relative">
        <a
          class="right-sidebar-button relative z-50"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-scalein"
          leaveActiveClass="animate-fadeout"
          leaveToClass="hidden"
          [hideOnOutsideClick]="true"
        >
          <span class="w-2 h-2 rounded-full bg-red-500 absolute top-2 right-2.5"></span>
          <i class="pi pi-bell"></i>
        </a>
        <div
          class="list-none m-0 py-4 px-4 rounded-3xl border border-surface absolute bg-surface-0 dark:bg-surface-900 overflow-hidden hidden origin-top min-w-72 sm:w-[24rem] mt-2 right-0 z-50 top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
        >
          <div
            class="list-none m-0 py-4 px-4 rounded-3xl border border-surface absolute bg-surface-0 dark:bg-surface-900 overflow-hidden hidden origin-top w-80 sm:w-[28rem] mt-2 sm:right-0 sm:left-auto left-[-8rem] z-50 top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
          >
            <span class="text-lg font-semibold text-surface-950 dark:text-surface-0"
              >Notificaciones</span
            >
            <button pRipple class="text-surface-700 dark:text-surface-300 text-sm font-semibold">
              Marcar como leídas
            </button>
          </div>
          <div
            class="my-2 shadow-custom-shadow border border-surface-200 dark:border-surface-800 bg-white/55 dark:bg-white/8 flex items-center gap-2 rounded-full p-1"
          >
            @for (item of notificationsBars(); track item.id; let i = $index) {
              <button
                [ngClass]="{
                  'bg-primary-100 dark:bg-primary-900': selectedNotificationBar() === item.id,
                  'hover:bg-primary-100/30 dark:hover:bg-primary-900/30':
                    selectedNotificationBar() !== item.id,
                }"
                class="rounded-full p-2 flex-1 flex items-center justify-center transition-all"
                (click)="selectedNotificationBar.set(item.id)"
              >
                <span class="capitalize font-semibold text-surface-950 dark:text-surface-0">{{
                  item.label
                }}</span>
              </button>
            }
          </div>

          <p-floatlabel variant="in" class="my-3">
            <p-datepicker
              [(ngModel)]="rangeDates"
              selectionMode="range"
              [readonlyInput]="true"
              inputId="range"
              dateFormat="dd' 'M' del 'yy"
              filled
              fluid
              showClear
            />
            <label for="range">Buscar por fechas</label>
          </p-floatlabel>

          <ul class="flex flex-col gap-8">
            <!-- @for (item of selectedNotificationsBarData(); track item.name; let i
            = $index) {
            <li class="flex gap-3">
              <div class="flex flex-col items-center gap-1">
                <p-overlay-badge value="" severity="danger" class="inline-flex">
                  <p-avatar size="large">
                    <img [src]="item.image" class="rounded-lg" />
                  </p-avatar>
                </p-overlay-badge>
                <span
                  class="flex-1 w-px bg-surface-200 dark:bg-surface-800"
                ></span>
              </div>
              <div class="flex-1 pt-2 space-y-2">
                <div class="flex items-center justify-between gap-2">
                  <span
                    class="font-semibold text-surface-950 dark:text-surface-0"
                    >{{ item.name }}</span
                  >
                  <div
                    class="text-sm text-surface-700 dark:text-surface-200 flex items-center gap-1"
                  >
                    {{ item.time }}
                    <div
                      *ngIf="!item.read"
                      class="!w-2 !h-2 rounded-full bg-green-500"
                    ></div>
                  </div>
                </div>
                <div
                  class="p-2 bg-surface-100 dark:bg-surface-800 border border-surface rounded-lg"
                >
                  <p
                    class="text-sm text-surface-700 dark:text-surface-200 line-clamp-2 text-ellipsis"
                  >
                    {{ item.description }}
                  </p>
                </div>
                <div
                  *ngIf="item.attachment"
                  class="p-2 bg-surface-100 dark:bg-surface-800 border border-surface rounded-lg flex items-start gap-3"
                >
                  <div
                    class="w-8 h-8 flex items-center justify-center rounded-md shadow-sm bg-surface-0 dark:bg-surface-950"
                  >
                    <i class="pi pi-file-pdf text-primary"></i>
                  </div>
                  <div class="flex-1 flex flex-col gap-0.5">
                    <span
                      class="text-sm font-semibold text-surface-700 dark:text-surface-200"
                      >{{ item.attachment.title }}</span
                    >
                    <span
                      class="text-xs text-surface-700 dark:text-surface-200"
                      >{{ item.attachment.size }}</span
                    >
                  </div>
                  <p-button
                    icon="pi pi-download"
                    severity="contrast"
                    styleClass="!w-8 !h-8 !p-0"
                  ></p-button>
                </div>
              </div>
            </li>
            } -->
          </ul>
        </div>
      </li>
      <li class="profile-item static sm:relative">
        <a
          pButton
          severity="secondary"
          rounded
          class="right-sidebar-button relative z-50"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="animate-scalein"
          leaveActiveClass="animate-fadeout"
          leaveToClass="hidden"
          [hideOnOutsideClick]="true"
        >
          <div class="flex flex-col max-w-36 ml-1 overflow-hidden text-left">
            <div
              class="font-semibold text-xs truncate"
              title="{{ account.first_name }} {{ account.last_name }}"
            >
              {{ account.first_name }} {{ account.last_name }}
            </div>
            @if (account.roles?.length) {
              <div
                class="text-[10px] text-primary truncate leading-tight"
                title="{{ account.roles?.[0]?.name }}"
              >
                {{ account.roles?.[0]?.name }}
              </div>
            }
          </div>
          @if (account.photo_url) {
            <p-avatar styleClass="!w-10 !h-10 !rounded-full !bg-transparent !overflow-hidden">
              <img
                [src]="account.photo_url"
                [alt]="account.first_name + ' ' + account.last_name"
                class="object-cover w-10 h-10"
                (error)="showAvatar()"
              />
            </p-avatar>
          } @else {
            <p-avatar
              [label]="account.first_name![0] + account.last_name![0]"
              shape="circle"
              styleClass="!text-sm"
              size="large"
            />
          }
        </a>
        <div
          class="list-none p-2 m-0 rounded-2xl border border-surface overflow-hidden absolute bg-surface-0 dark:bg-surface-900 hidden origin-top w-52 mt-2 right-0 z-[999] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
        >
          <ul class="flex flex-col gap-1">
            <li>
              <a
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                [routerLink]="['/user/profile']"
              >
                <i class="pi pi-user"></i>
                <span>Perfil</span>
              </a>
            </li>
            <li>
              <a
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                [routerLink]="['/user/settings']"
              >
                <i class="pi pi-cog"></i>
                <span>Ajustes</span>
              </a>
            </li>
            <li>
              <a
                class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer"
                [routerLink]="['/user/calendar']"
              >
                <i class="pi pi-calendar"></i>
                <span>Calendario</span>
              </a>
            </li>
            <hr />
            <li>
              <a
                class="label-small text-blue-500 dark:blue-red-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-blue-500/10 transition-colors duration-150 cursor-pointer"
                (click)="changeAccount()"
                tabindex="0"
                role="button"
                (keydown.enter)="changeAccount()"
              >
                <i class="pi pi-arrow-right-arrow-left"></i>
                <span>Cambiar cuenta</span>
              </a>
            </li>
            <li>
              <a
                class="label-small text-red-500 dark:text-red-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-red-500/10 transition-colors duration-150 cursor-pointer"
                (click)="logout()"
                tabindex="0"
                role="button"
                (keydown.enter)="logout()"
              >
                <i class="pi pi-power-off"></i>
                <span>Cerrar sesión</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</div>
